import "isomorphic-fetch";
import * as msal from "@azure/msal-browser";
import { Client } from "@microsoft/microsoft-graph-client";
import {v4 as uuidv4 } from 'uuid'
import moment from 'moment';
import tippy from 'tippy.js';
import {hideAll} from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
// import sanitizeHtml from "sanitize-html";
import { EVENT_TYPE_MAP, MSAL_CONFIG, TEAMS_ICON, USER_STATUS_MAP } from "./constants";
import { chat, permissions, socket, Video } from "../../../libs/roomnew";
import { renderChatsList, updateChatBadge } from "../../chat/chatsList";
import { logError, notifyUser } from '../../../utils/errorHandler';
export default class TeamsApi{
    static CACHE_PREFIX = 'teams_';
    static CACHE_CHATS_KEY = 'teams_chats_';
    static CACHE_MESSAGES_KEY = 'teams_messages_';
    static CACHE_MAX_MESSAGES_PER_CHAT = 100;
    static CACHE_TTL_MS = 24 * 60 * 60 * 1000;

    constructor(){
        this.account=null;
        this.avatarMenuButton = $('#nav-chat-avatar');
        this.msalInstance = new msal.PublicClientApplication(MSAL_CONFIG);
        this.localChats = [];
        this.loginRequest = {
            scopes: [
                'User.ReadBasic.All',
                'Chat.Create',
                'Chat.Read',
                'Chat.ReadWrite',
                'Chat.ReadBasic',
                'ChatMessage.Read',
                'ChatMessage.Send',
                'People.Read',
                'Presence.Read.All',
                'Presence.ReadWrite',
                'email',
                'openid',
                'profile',
            ],
        };
        this.people = [];
        this.presenceTimeout = 0;
        this.nextLink = null;
        this.enabled = false;
    }

    getCacheKey(type, id = '') {
        const accountId = this.account?.localAccountId ?? 'unknown';
        return `${type}${accountId}${id ? '_' + id : ''}`;
    }

    saveToCache(key, data) {
        try {
            const payload = { data, timestamp: Date.now() };
            localStorage.setItem(key, JSON.stringify(payload));
        } catch (e) {
            console.warn('Teams cache write failed', e);
        }
    }

    loadFromCache(key) {
        try {
            const raw = localStorage.getItem(key);
            if (!raw) return null;
            const payload = JSON.parse(raw);
            if (Date.now() - payload.timestamp > TeamsApi.CACHE_TTL_MS) {
                localStorage.removeItem(key);
                return null;
            }
            return payload.data;
        } catch (e) {
            console.warn('Teams cache read failed', e);
            return null;
        }
    }

    saveChatGroupsToCache(groups) {
        const key = this.getCacheKey(TeamsApi.CACHE_CHATS_KEY);
        this.saveToCache(key, groups);
    }

    loadChatGroupsFromCache() {
        const key = this.getCacheKey(TeamsApi.CACHE_CHATS_KEY);
        return this.loadFromCache(key);
    }

    saveMessagesToCache(chatId, messages) {
        const key = this.getCacheKey(TeamsApi.CACHE_MESSAGES_KEY, chatId);
        const trimmed = messages.slice(-TeamsApi.CACHE_MAX_MESSAGES_PER_CHAT);
        this.saveToCache(key, trimmed);
    }

    loadMessagesFromCache(chatId) {
        const key = this.getCacheKey(TeamsApi.CACHE_MESSAGES_KEY, chatId);
        return this.loadFromCache(key);
    }

    appendMessageToCache(chatId, message) {
        const cached = this.loadMessagesFromCache(chatId) ?? [];
        if (!cached.find(m => m.id === message.id)) {
            cached.push(message);
        }
        this.saveMessagesToCache(chatId, cached);
    }

    async init(){
        if(!permissions.hasTeamsIntegrationAddon()){
            this.renderUTeamsAddonUnavailable();
            return
        }
        this.enabled = true
        await this.msalInstance.initialize();
        const isSignin = this.checkSignIn();

        if(isSignin){
            this.onSignin();
        }
        socket.events.WebhookMessage = async (message) => {
            const data = message.data;
            console.log("Webhook message",data);
            if(data.encryptedData && parseInt(data.user_id) == USER_ID){
                const decodedData = atob(data.encryptedData);
                const eventData = JSON.parse(decodedData);
                console.log("Event data",eventData);
                if(data.type === "message"){
                    if(eventData.messageType=="unknownFutureValue"){
                        return;
                    }
                    const group = chat.groups.find(g=> g.id == eventData.chatId)
                    if(!group){
                        //get the chat
                        const chat = this.getChat(eventData.chatId);
                        const kinoChat = await this.buildKinoGroupFromChat(chat);
                        this.groups.push(kinoChat);

                    }
                    const kinoMessage = await this.buildKinoMessageFromChatMessage(eventData);
                    // console.log("Kino message",kinoMessage);
                    const groupMessages = chat.messages[kinoMessage.group_id] ?? [];
                    // console.log("Group messages",groupMessages);
                    const messageExists = groupMessages.find((m)=>m.id==kinoMessage.id);
                    // console.log("Message exists",messageExists);
                    if(!messageExists){
                        this.MessageReceived(kinoMessage);
                    }
                    // chat.addMessage(kinoMessage);
                }
            }else if(data.type === "re-subscribe"){
                console.log("Re subscribe request",data);
            }
        }
        this.updatePresenceStatus()
    }

    checkSignIn(){
        const accounts = this.msalInstance.getAllAccounts();
        console.log("MS instance",this.msalInstance)
        console.log("Checking account:",accounts);
        const account = accounts[0];
        if (!account) {
            console.error('No accounts detected');
            this.renderUnAuthenticated()
            return false;
        }
        this.hideUnAuthenticated();
        this.account=account;
        return true;
    }

    onSignin(){
        this.getProfilePicture();
        this.buildAvatarMenu();
        this.subscribeToNotifications();
        this.getPeople().then(people => {
            this.people = people;
        })

        const cachedGroups = this.loadChatGroupsFromCache();
        if (cachedGroups && cachedGroups.length) {
            this.localChats = cachedGroups;
            chat.groups = cachedGroups;
            renderChatsList();
        }

        this.getChats().then((chats)=>{
            renderChatsList();
        });

        this.setPresence();
        this.startPresenceKeeAlive();
    }

    buildAvatarMenu(){
        const menuItems=$('<div/>',{
            class:'menu-items'
        });
        const mute=$('<div>',{
            class:'menu-item',
            html:`<span class="menu-icon">${Video.showTheDoorIcon}</span><span class="menu-text ellipsis">Sign Out</span>`
        }).on('click',()=>{
            hideAll();
            this.signOut();
        });
        menuItems.append(mute)
        tippy(this.avatarMenuButton[0],{
            content:menuItems[0],
            trigger: 'click',
            placement: 'bottom-end',
            allowHTML: true,
            theme:'light',
            arrow:false,
            zIndex: 1000,
            interactive:true,
            appendTo: () => document.body
        });
        this.showAvatarIcon();
    }

    hideAvatarIcon() {
        this.avatarMenuButton.addClass('d-none');
    }
    showAvatarIcon() {
        this.avatarMenuButton.removeClass('d-none');
    }

    renderUTeamsAddonUnavailable(){
        const container=$("#authenticate-chat")
        const title = $('<div/>',{
            class: "chat-addon-title",
            html:[
                 `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="50" height="50" x="0" y="0" viewBox="0 0 100 100" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path fill="#464eb8" d="M84.025 35.881c5.797 0 10.513-4.729 10.513-10.54-.577-13.983-20.45-13.979-21.026 0 0 5.811 4.717 10.54 10.513 10.54z" opacity="1" data-original="#464eb8" class=""></path><path fill="#464eb8" d="M90.958 38.71H51.61v-3.68c.784.139 1.605.232 2.467.268.093.001.186-.006.279-.007a15.5 15.5 0 0 0 1.063-.053c.12-.011.239-.021.357-.035.403-.045.801-.104 1.193-.181.024-.005.05-.008.074-.012a14.377 14.377 0 0 0 5.167-2.17 14.504 14.504 0 0 0 3.693-3.615c.26-.341.497-.697.718-1.061.021-.036.044-.07.065-.107.17-.287.32-.584.466-.884.064-.13.13-.26.19-.392.154-.345.296-.696.421-1.053l.032-.088c1.427-4.208.774-9.156-1.676-12.856a14.476 14.476 0 0 0-2.268-2.574c-.176-.153-.344-.314-.529-.457a14.41 14.41 0 0 0-3.567-2.159 12.49 12.49 0 0 0-1.347-.493c-.264-.081-.538-.141-.808-.207-.239-.058-.475-.121-.717-.166-.2-.038-.405-.062-.607-.092-.352-.05-.704-.096-1.06-.121-.122-.009-.245-.012-.368-.018a14.095 14.095 0 0 0-1.088-.007c-2.08.121-3.926.558-5.543 1.24-.33.149-.664.294-.975.47-3.242 1.766-5.722 4.772-6.867 8.293a15.274 15.274 0 0 0-.187 8.129l.02.076.097.345c.039.137.085.273.128.409.039.11.08.219.121.329H8.774a5.168 5.168 0 0 0-5.162 5.162v37.672a5.168 5.168 0 0 0 5.162 5.162h20.122c.026.118.059.232.087.349 2.77 10.899 12.463 18.607 23.917 18.885 9.503-.231 17.666-5.721 21.753-13.592.061.022.124.038.185.059 10.182 3.851 21.752-4.229 21.546-15.131V44.122c.001-2.984-2.434-5.412-5.426-5.412z" opacity="1" data-original="#464eb8" class=""></path><path fill="#7b83eb" d="M77.444 44.232c.069-2.971-2.287-5.448-5.251-5.521H50.761a1.43 1.43 0 0 0-1.429 1.433v29.095a2.433 2.433 0 0 1-2.428 2.433H30.199a1.429 1.429 0 0 0-1.399 1.721c2.367 11.561 12.248 19.837 24.1 20.126 13.856-.34 24.866-11.914 24.544-25.767zM54.077 35.298c.093.001.186-.006.279-.007.358-.005.713-.023 1.064-.053.12-.011.239-.021.357-.035.402-.045.801-.104 1.193-.181l.074-.013a14.377 14.377 0 0 0 5.167-2.17 14.508 14.508 0 0 0 3.694-3.615c.26-.341.497-.697.718-1.061.021-.036.044-.07.065-.107.17-.287.32-.585.466-.884.064-.13.13-.259.19-.392.154-.345.297-.696.421-1.053l.032-.088c1.427-4.208.774-9.157-1.676-12.856a14.476 14.476 0 0 0-2.268-2.574c-.176-.153-.344-.314-.529-.457a14.41 14.41 0 0 0-3.567-2.159A12.49 12.49 0 0 0 58.41 7.1c-.264-.081-.538-.14-.808-.207-.239-.058-.475-.121-.717-.166-.2-.038-.404-.062-.607-.092-.352-.05-.704-.096-1.06-.121-.122-.009-.245-.012-.367-.018a15.179 15.179 0 0 0-1.088-.005c-2.08.121-3.926.557-5.543 1.24-.33.149-.664.294-.975.47-3.242 1.767-5.723 4.773-6.867 8.294a15.274 15.274 0 0 0-.187 8.129l.02.076.097.345c.039.137.085.273.128.409.06.171.123.34.187.51h-.027c1.775 4.977 6.268 9.029 13.481 9.334z" opacity="1" data-original="#7b83eb"></path><path fill="#464eb8" d="M46.448 25.783H8.774a5.168 5.168 0 0 0-5.162 5.162v37.672a5.168 5.168 0 0 0 5.162 5.162h37.674a5.167 5.167 0 0 0 5.161-5.162V30.945a5.166 5.166 0 0 0-5.161-5.162z" opacity="1" data-original="#464eb8" class=""></path><path fill="#ffffff" d="M37.109 36.271h-19.28c-.771 0-1.395.625-1.395 1.396v3.514c0 .771.624 1.396 1.395 1.396h6.22v19.575c0 .771.624 1.396 1.395 1.396h4.134c.771 0 1.395-.625 1.395-1.396V42.577h6.136c.771 0 1.395-.625 1.395-1.396v-3.514c0-.771-.624-1.396-1.395-1.396z" opacity="1" data-original="#ffffff"></path></g></svg>`,
                `<h6 class="text-bold text-center text-white">Microsoft Teams Integration add-on not available</h6>`
            ]
        });
        const description = $("<p/>",{
            class:"text-center",
            text:"This workspace is using Microsoft Teams chat for communication, ask workspace manager to enable Microsoft Teams Integration add-on on your account."
        })
        container.html([title,description]);
        container.removeClass("d-none").addClass("d-flex");
        this.account=null;
        clearTimeout(this.presenceTimeout);
        this.hideAvatarIcon();
    }


    renderUnAuthenticated(){
        const container=$("#authenticate-chat")
        const button=$("<button/>",{
            class:"btn-blur authenticate-chat-btn",
            html:[TEAMS_ICON,"Authenticate Teams"],
        }).on("click",()=>{
            this.signIn();
        })
        const description = $("<p/>",{
            class:"text-center",
            text:"Authenticate with your Microsoft account to view your Microsoft Teams chats"
        })
        container.html([description,button]);
        container.removeClass("d-none").addClass("d-flex");
        this.hideAvatarIcon();
        this.account=null;
        clearTimeout(this.presenceTimeout);
    }

    hideUnAuthenticated(){
        const container=$("#authenticate-chat")
        container.addClass("d-none").removeClass("d-flex");
        container.html("");
    }

    async signIn(){
        try {
            const loginResponse = await this.msalInstance.loginPopup(this.loginRequest);
            console.log('id_token acquired at: ' + new Date().toString());
            console.log("Logn successful",loginResponse);
            this.account=loginResponse.account;
            this.hideUnAuthenticated();
            this.onSignin();
          } catch (error) {
            logError(error, 'teamsSignIn'); notifyUser('Teams sign-in failed.');
          }
    }

    signOut() {
        const account = this.msalInstance.getAllAccounts()[0];
        if (!account) {
          console.error('No accounts detected');
          return;
        }
        console.log("Signing out",account);
        this.msalInstance.logoutPopup({
          account: account
        }).then(() => {
          console.log('User signed out');
          document.getElementById('authenticated-user-image').src = ''; // Clear profile picture
          this.hideAvatarIcon();
          this.renderUnAuthenticated();
        }).catch(error => {
          console.error(error);
        });
      }

    async setPresence(){
        this.getClient().then(async (client)=>{
            const appId = MSAL_CONFIG.auth.clientId;
            const setPresence = {
                sessionId: appId,
                availability: 'Available',
                activity: 'Available',
                expirationDuration: 'PT5M'
              };
            const presence = await client.api('/me/presence/setPresence').post(setPresence);
            console.log("Presence SET ",presence)
              return presence
        }).catch((error)=>{
            console.error(error)
            return error
        })
    }

    startPresenceKeeAlive() {
        clearTimeout(this.presenceTimeout)
        this.presenceTimeout = setTimeout(() => {
            if(this.account){
                this.setPresence().then(()=>this.startPresenceKeeAlive());
            }
        }, 250000);
    }

    getClient(){
        return new Promise(async (resolve,reject)=>{
            try {
                if(!this.account){
                    this.renderUnAuthenticated();
                    this.hideAvatarIcon();
                   reject(new Error("No accounts detected"));
                }

                const response = await this.msalInstance.acquireTokenSilent({...this.loginRequest,account:this.account});
                const accessToken = response.accessToken;

                const client = Client.init({
                  authProvider: (done) => {
                    done(null, accessToken);
                  },
                });

                resolve(client);
              } catch (error) {
                  console.error("Get client error",error);
                  this.renderUnAuthenticated();
                      this.hideAvatarIcon();
                reject(error);
              }

        })
    }

    getProfilePicture(){
        this.getClient().then(async (client)=>{
            const photo = await client.api('/me/photo/$value').get();
            const url = URL.createObjectURL(photo);

            const img = document.getElementById('authenticated-user-image');
            img.src = url;
            img.alt = 'Profile Picture';
            this.showAvatarIcon();
        }).catch((error)=>{
            this.hideAvatarIcon();
        })
    }

    getChats() {
        return new Promise((resolve,reject)=>{
            this.getClient().then(async (client)=>{
                try {
                  const chats = await client.api('/me/chats?$expand=members,lastMessagePreview').get();
                  console.log(chats);
                  const kinoGroups = [];
                  for(let chat of chats.value){
                      console.log(chat)
                      const kinoChat = await this.buildKinoGroupFromChat(chat);
                      kinoGroups.push(kinoChat);
                  }
                  console.log("Kino Chats",kinoGroups)
                  this.localChats = kinoGroups;
                  chat.groups = kinoGroups;
                  this.saveChatGroupsToCache(kinoGroups);
                  resolve(kinoGroups);
                } catch (error) {
                  console.error(error);
                  reject(error);
                }

            })

        });

    }
    getChat(chatId) {
        return new Promise((resolve,reject)=>{
            this.getClient().then(async (client)=>{
                try {
                  const chat = await client.api(`/me/chats/${chatId}?$expand=members,lastMessagePreview`).get();
                  resolve(chat);
                } catch (error) {
                  console.error(error);
                  reject(error);
                }

            })

        });

    }

    getParticipants() {
        return this.people.map(p=>({
            id: p.id,
            name: p.displayName,
            email: p.mail,
            user_id: p.id,
            joined: "joined",
        }))
    }
    getAvailableParticipantsToChat(filter = ""){
        const participants = this.getParticipants().filter((p) => p.name.toLowerCase().search(filter.toLowerCase()) > -1);
          return participants
            .filter((p) => !chat.selectedParticipantsToMessage.includes(p.id));
    }

    async createNewChat(participants) {
        if(!participants.find(p=>p.guest_id===this.account.localAccountId)){
            participants.unshift({
                guest_id: this.account.localAccountId
            })
        }
        const members = participants.map(p=>({
            '@odata.type': "#microsoft.graph.aadUserConversationMember",
            roles: [
                "owner"
            ],
            'user@odata.bind': `https://graph.microsoft.com/v1.0/users('${p.guest_id}')`
        }))
        const createdChat = await this.createChat(members);
        const chat = await this.getChat(createdChat.id);
        console.log("Created Chat is ",chat)
        const kinoChat = await this.buildKinoGroupFromChat(chat);
        return {data: kinoChat};
    }

    getLocalChats(){
        return chat.groups.filter(g=>g?.isExternal);
    }

    updatePresenceStatus(){
        setInterval(async ()=>{
            if(this.account){
                const privateChats = chat.groups.filter(g=>!g.isGroup);
                for (let index = 0; index < privateChats.length; index++) {
                    const group = privateChats[index];
                    const otherMembers = group.members.filter(user=>user.user_id !== this.account.localAccountId);
                    if(otherMembers[0]){
                        const presence = await this.getUserPresence(otherMembers[0].user_id);
                        const userstatus = USER_STATUS_MAP[presence.availability];
                        group.isOnline = userstatus;
                    }
                }
                renderChatsList()
            }
        },60000)
    }

    async buildKinoGroupFromChat(chat){

        const status = chat.chatType === "group" ? 'offline' : await this.getPresenceStatus(chat)
        return {
            pId: chat.id,
            group: chat.id,
            id: chat.id,
            name: this.getChatName(chat),
            members: this.getChatMembers(chat),
            isChat: true,
            isGroup: chat.chatType === "group",
            lastMessage: this.getChatLastMessage(chat),
            lastMessageTime: moment.utc(chat.lastMessagePreview?.createdDateTime),
            isOnline: status,
            unread: 0,
            isExternal: true
        }
    }
    getPresenceStatus(chat){
        return new Promise(async (resolve,reject)=>{
            const otherMembers = chat.members.filter(user=>user.userId !== this.account.localAccountId);
            if(otherMembers.length===1){
                try {
                  const presence = await this.getUserPresence(otherMembers[0].userId);
                  resolve(USER_STATUS_MAP[presence.availability]);
                } catch (error) {
                  console.error(error);
                  reject(error);
                }
            }else{
                resolve('offline');
            }
        })
    }

    getChatLastMessage(chat) {
        if (chat.lastMessagePreview) {

            if(chat.lastMessagePreview.messageType=="unknownFutureValue"){
                return EVENT_TYPE_MAP[chat.lastMessagePreview.eventDetail["@odata.type"]];
            }

            const contentType = chat.lastMessagePreview?.body.contentType;
            const content = chat.lastMessagePreview?.body.content;

            if (contentType === 'text') {
                return content.substring(0, 50);
            } else if (contentType === 'html') {
                const parser = new DOMParser();
                const doc = parser.parseFromString(content, 'text/html');

                if (doc.querySelector('a')) {
                    return doc.body.innerText.replace("Sent via Kino Co-Working Space. Click to Enter",'').replace("Sent via Kino Workspace. Click to Enter",'').substring(0, 50);
                } else if (doc.querySelector('video')) {
                    return '🎥 Video';
                } else if (doc.querySelector('img')) {
                    return '📷 Image';
                } else if (doc.querySelector('p')) {
                    return doc.querySelector('p').innerText.substring(0, 50);
                }else {
                    return '📄 File';
                }
            }
        }
        return 'No messages';
    }

    getChatMembers(chat,includeMe = true){
        console.log("Chat members",chat.members)
        return chat.members.map((m) => {
            return {
                guest_id: m?.guest_id ?? m?.userId,
                displayName: m.displayName,
                user_id: m?.user_id ?? m?.userId,
                email: m.email
            }
        }).filter(m=>m.user_id != this.account.localAccountId || includeMe);
    }
    getChatName(chat){

        if(chat.topic){
            return chat.topic;
        }
        const otherMembers = chat.members.filter(user=>user.userId !== this.account.localAccountId);
        if(!otherMembers.length){
            return 'Just me';
        }
        const name = otherMembers.map((m) => m.displayName).join(', ');
        return name;
    }

    getUserPresence(userId) {
        return new Promise(async (resolve, reject) => {
            try {
                this.getClient().then(async (client)=>{
                    const presence = await client.api(`/users/${userId}/presence`).get();
                    resolve(presence);

                }).catch(error=>{
                    reject(error);
                })
            } catch (error) {
              console.error(error);
              reject(error);
            }
        })

    }

    getMediaUrl(url) {
        return new Promise(async (resolve, reject) => {
                try {
                    this.getClient().then(async (client)=>{
                        console.log("Getting media url",url);
                        const response = await client.api(url).get();
                        console.log("Response",response);
                        // const blob = await response.blob();
                        const objectURL = response instanceof ReadableStream ? response : URL.createObjectURL(response);
                        console.log("Object URL",response);
                        resolve(objectURL);
                    }).catch(error=>{
                        console.log("err",error)
                        resolve(url);
                    })
                } catch (error) {
                    console.error(error);
                    resolve(url);
                }
        })
}

    async loadOlderMessages(chatId){
        if(this.nextLink){
            return this.getMessages(chatId,this.nextLink)
        }
        return null
    }

    getMessages(chatId,query="?$top=20&$orderby=createdDateTime desc"){
        return new Promise((resolve,reject)=>{
            try {
                this.getClient().then(async (client)=>{
                    const messages = await client.api(`/chats/${chatId}/messages${query}`).get();
                    console.log("original messages",messages);
                    this.nextLink = "?$top=20&$orderby=createdDateTime desc&$skiptoken="+this.getSkipTokenFromUrl(messages['@odata.nextLink']);
                    const kinoMessages = [];
                    for(let message of messages.value){
                        if(message.messageType=="unknownFutureValue"){
                            continue;
                        }
                        console.log("Message",message);
                        const kinoMessage = await this.buildKinoMessageFromChatMessage(message);
                        kinoMessages.push(kinoMessage);
                    }
                    const result = kinoMessages.reverse();
                    this.saveMessagesToCache(chatId, result);
                    resolve(result);
                }).catch(error=>{
                    reject(error);
                })
            } catch (error) {
              console.error(error);
              reject(error);
            }
        })
    }

    getCachedMessages(chatId) {
        return this.loadMessagesFromCache(chatId);
    }

    getSkipTokenFromUrl(nextLink) {
        // Create a URL object to parse the nextLink
        const url = new URL(nextLink);

        // Extract the value of the skipToken parameter from the query string
        const skipToken = url.searchParams.get('$skiptoken');
        return skipToken;
    }

    createChat(members){
        return new Promise((resolve, reject) =>{
            try {
                this.getClient().then(async (client)=>{
                    const chatRequestBody = {
                        chatType: members.length > 2 ? "group" : "oneOnOne",
                        members: members
                    };
                    const chat = await client.api(`/chats`).post(chatRequestBody);
                    console.log("The chat response",chat)
                    resolve(chat)
                }).catch(error=>{
                    reject(error);
                })
            } catch (error) {
                console.error(error);
              reject(error);
            }
        })
    }

    getPeople(){
        return new Promise((resolve, reject) =>{
            try {
                this.getClient().then(async (client)=>{
                    const peopleResponse = await client.api(`/users`).get();
                    const people = peopleResponse.value;
                    console.log("People",people)
                    resolve(people)
                }).catch(error=>{
                    reject(error);
                })
            } catch (error) {
                console.error(error);
              reject(error);
            }
        })
    }

    async buildKinoMessageFromChatMessage(message){
        const images = await this.extractMediaUrlsFromMessage(message,'img');
        const videos = await this.extractMediaUrlsFromMessage(message,'video');
        return {
            id: message.id,
            sender: message?.from?.user?.id,
            sender_user_id: message?.from?.user?.id,
            sender_name: message?.from?.user?.displayName,
            message: this.getMessageText(message),
            images: images,
            videos: videos,
            importance: message?.importance,
            created_at: message.createdDateTime,
            mentions: message.mentions,
            read_by: [],
            group_id: message.chatId,
            external: true,
            attachments: message.attachments
          }
    }

    async extractMediaUrlsFromMessage(message,mediaTag) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(message.body.content, 'text/html');
        const medias = doc.querySelectorAll(mediaTag);
        const mediaUrls = [];
        for (let i = 0; i < medias.length; i++) {
            const media = medias[i];
            const privateSrc = media.src;
            // const publicSrc = await this.getMediaUrl(privateSrc);
            mediaUrls.push(privateSrc);
        }
        return mediaUrls;
    }

    getMessageText(message){
        if(message.messageType=="unknownFutureValue"){
            return EVENT_TYPE_MAP[message.eventDetail["@odata.type"]];
        }else{
            return message.body.content;
        }
    }

    isMyMessage(message){
        return message.sender_user_id === this.account.localAccountId;
    }

    sendMessage(message){
        return new Promise((resolve,reject)=>{
            try {
                this.getClient().then(async (client)=>{
                    const chatId = message.group_id;
                    const attachments = [];
                    let messageBodyHtml = message.message??'';
                    message.images.forEach((image)=>{
                        attachments.push({
                            contentType: "reference",
                            contentUrl: image.uploaded.sharableLink,
                            id: image.uploaded.attachment_id,
                            name: image.name
                        })
                    })
                    message.videos.forEach((video)=>{
                        attachments.push({
                            contentType: "reference",
                            contentUrl: video.uploaded.sharableLink,
                            id: video.uploaded.attachment_id,
                            name: video.name
                        })
                    })
                    message.attachments.filter(a=>!a.isInline).forEach((att)=>{
                        attachments.push({
                            contentType: "reference",
                            contentUrl: att.uploaded.sharableLink,
                            id: att.uploaded.attachment_id,
                            name: att.name
                        })
                    })

                    let {messageBody,hostedContents} = this.buildHostedContent(messageBodyHtml);
                    let {messageBody2,mentions} = this.buildMentions(messageBody);

                    if(message.replyTo){
                        const replyAttachment={
                            contentType:"messageReference",
                            content:JSON.stringify({
                                messageId: message.replyTo.id,
                                messagePreview: chat.formatLastMessage(message.replyTo.message,100),
                                messageSender:{
                                    user:{
                                        id: message.replyTo.sender_user_id,
                                        displayName: message.replyTo.sender_name
                                    }
                                }
                            }),
                            id: message.replyTo.id
                        }
                        messageBody2 = `
                        <attachment id="${replyAttachment.id}"></attachment>
                        `+messageBody2;
                        attachments.push(replyAttachment);
                    }


                    const roomUrl = `${window.KINO_APP_URL || window.location.origin}/${ROOM_NAME}`;
                    messageBody2 += `
                        <a href="${roomUrl}" rel="noreferrer noopener" style="display:inline-block;margin-top:6px;padding:4px 10px;background-color:#464eb8;color:#ffffff;text-decoration:none;border-radius:4px;font-size:12px;" title="Join Kino Co-Working Space" target="_blank" data-original-title="${roomUrl}">Sent via Kino Co-Working Space. Click to Enter</a>`
                    const messageContent = {
                        body: {
                            contentType: "html",
                            content: messageBody2,
                        },
                        attachments: attachments,
                        hostedContents: hostedContents,
                        mentions: mentions
                    }
                    console.log("Sending message",messageContent);
                    const response = await client.api(`/chats/${chatId}/messages`).post(messageContent);
                    console.log("Message sent",response);
                    const kinoMessage = await this.buildKinoMessageFromChatMessage(response);
                    chat.storeGroupMessage(chatId,kinoMessage);
                    resolve(kinoMessage);
                }).catch(error=>{
                    reject(error);
                })
            } catch (error) {
              console.error(error);
              reject(error);
            }
        })
    }

    buildHostedContent(message){
        const parser = new DOMParser();
        const doc = parser.parseFromString(message, 'text/html');
        const mediaElements = doc.querySelectorAll('img,video');
        const hostedContents = [];
        for(let media of mediaElements){
            const imageData = media.getAttribute('src');
            const mediaType = imageData.split(';')[0].split(':')[1];
            const base64data = imageData.split(',')[1];
            const attachmentId = uuidv4();
            if(imageData){
                media.src = `../hostedContents/${attachmentId}/$value`;
                hostedContents.push({
                    '@microsoft.graph.temporaryId': attachmentId,
                    contentType: mediaType,
                    contentBytes: base64data,
                });
            }
        }
        return {messageBody:doc.body.innerHTML,hostedContents:hostedContents};
    }

    buildMentions(message){
        const parser = new DOMParser();
        const doc = parser.parseFromString(message, 'text/html');
        const mediaElements = doc.querySelectorAll('at');
        const mentions = [];
        let index = 0;
        for(let media of mediaElements){
            const userId = media.getAttribute('id');
            if(userId){
                media.id = index;
                mentions.push({
                    id: index,
                    mentioned: {
                        '@odata.type': "microsoft.graph.chatMessageMentionedIdentitySet",
                        user: {
                            '@odata.type': "microsoft.graph.teamworkUserIdentity",
                            id: userId
                        }
                    },
                    mentionText: media.innerHTML
                });
                index ++
            }
        }
        return {messageBody2:doc.body.innerHTML,mentions:mentions};
    }

    async MessageReceived(message) {
        if (message.group_id == chat.selectedChatId) {
        //   if (this.typingTimout) clearTimeout(this.typingTimout);
        //   $("#writing-message").html("");
        }


        chat.storeGroupMessage(message.group_id, message);
        this.appendMessageToCache(message.group_id, message);
        const group = chat.getGroupChatById(message.group_id);
        if (!group) {
        //   await this.createLocalGroup(message.group, true);
            console.error("Group not found for message",message);
        }

        chat.mainChat.sendMessage({
          eventName: "chatMessageReceived",
          ...message,
        });
        if (message.group_id == chat.selectedChatId) {
          updateChatBadge(message.group_id,0);
          chat.addMessageToHTML(message);
          chat.scrollToBottom();
        }else if(message.sender_user_id === this.account.localAccountId){
            //my message
            updateChatBadge(message.group_id,false);
        } else {
          chat.addGroupNotification(message.group_id);
          this.showTeamsNotification(message, group);
        }

        renderChatsList();
        chat.downloadMessageButton();
      }

    showTeamsNotification(message, group) {
        const groupName = group?.name ?? 'Teams';
        const senderName = message?.sender_name ?? 'Unknown';
        const msgPreview = chat.formatLastMessage(message.message, 80);

        const toast = $('<div/>', {
            class: 'teams-notification-toast',
            html: `
                <div class="teams-notification-header">
                    <span class="teams-notification-icon">${TEAMS_ICON}</span>
                    <strong class="teams-notification-sender">${senderName}</strong>
                    <span class="teams-notification-close">&times;</span>
                </div>
                <div class="teams-notification-group">${groupName}</div>
                <div class="teams-notification-body">${msgPreview}</div>
            `
        });

        toast.find('.teams-notification-close').on('click', (e) => {
            e.stopPropagation();
            toast.fadeOut(200, () => toast.remove());
        });

        toast.on('click', () => {
            chat.selectGroupChat(message.group_id);
            toast.fadeOut(200, () => toast.remove());
        });

        $('body').append(toast);
        toast.hide().fadeIn(300);

        setTimeout(() => {
            toast.fadeOut(400, () => toast.remove());
        }, 6000);
    }

    uploadAttachment(attachment){
        return new Promise((resolve,reject)=>{
            try {
                this.getClient().then(async (client)=>{
                    const body = {
                        item: {
                            '@odata.type': "microsoft.graph.driveItemUploadableProperties",
                            '@microsoft.graph.conflictBehavior': "rename",
                            name: attachment.name,
                        }
                    }
                    console.log("Request body",body)
                    const uploadSession = await client.api('me/drive/root:/Microsoft Teams Chat Files/' + attachment.name + ':/content')
                    // .post(body);
                    .header('Content-Type', 'application/text/plain')
                    .put(attachment.file);
                    const uploaded = {
                        url: uploadSession.webUrl,
                        id: uploadSession.id,
                        downloadUrl:uploadSession['@microsoft.graph.downloadUrl'],
                        name: uploadSession.name
                    };

                    const sharableLink = await this.createAttachmentSharableLink(uploaded);
                    console.log("Upload session",uploadSession);
                    resolve({
                        ...uploaded,
                        ...sharableLink
                    });
                }).catch(error=>{
                    reject(error);
                })
            }catch(error){
                console.error(error);
                reject(error);
            }
        })
    }

    createAttachmentSharableLink(attachment){
        return new Promise((resolve,reject)=>{
            try {
                this.getClient().then(async (client)=>{
                    const messageChat = chat.groups.find((g)=>g.id==chat.selectedChatId);
                    const recipients = messageChat.members.map((m)=>({
                        objectId: m.user_id,
                    }))
                    const body = {
                        type: "edit",
                        scope: "users",
                        recipients: recipients,
                        sendNotification: false
                    }

                    console.log("Request body",body)
                    const link = await client.api(`/me/drive/items/${attachment.id}/createLink`).post(body);
                    console.log("Link",link);
                    resolve({sharableLink:link.link.webUrl,attachment_id:link.id});
                }).catch(error=>{
                    reject(error);
                })
            }catch(error){
                console.error(error);
                reject(error);
            }
        })
    }

    subscribeToNotifications(){
        return new Promise((resolve,reject)=>{
            try {
                this.getClient().then(async (client)=>{
                    let subscriptions = await client.api('/subscriptions')
                    .get();
                    console.log("Subscriptions",subscriptions);
                    for(let subscription of subscriptions.value){
                        await client.api(`/subscriptions/${subscription.id}`).delete();
                    }
                    const base64encodedCertificate = process.env.MIX_MICROSOFT_GRAPH_CERTIFICATE;
                    const certificateID = process.env.MIX_MICROSOFT_GRAPH_CERTIFICATE_ID;
                    const domain = window.location.hostname;
                    const expirationDate = new Date();
                    expirationDate.setHours(new Date().getHours() + 2);
                    expirationDate.toISOString();
                    console.log("Expiration date",expirationDate);
                    const subscription = {
                        changeType: 'created,updated',
                        notificationUrl: `https://${domain}/api/webhooks/microsoft/notification/${ROOM_NAME}/${USER_ID}`,
                        lifecycleNotificationUrl: `https://${domain}/api/webhooks/microsoft/notification/${ROOM_NAME}/${USER_ID}`,
                        resource: `/users/${this.account.localAccountId}/chats/getAllMessages`,
                        includeResourceData: true,
                        encryptionCertificate: base64encodedCertificate,
                        encryptionCertificateId: certificateID,
                        expirationDateTime: expirationDate.toISOString(),
                        // clientState: 'SecretClientState'
                      };
                    const response = await client.api(`/subscriptions`).post(subscription);
                    console.log("Subscription response",response);
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                })
            } catch (error) {
              console.error(error);
              reject(error);
            }
        })
    }

}
